import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function actualAppConfig() {
    return axios.get(`${url}/admin_app_config`)
        .then(response => {
            return {
                actualAppConfig: response.data,
                meta: response.data.meta
            };
        });
}

function updateAppVersion(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/admin_app_config/updateVersion`,payload,options)
        .then(response => {
            return response.data;
        });
}

function updateDelayTime(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/admin_app_config/updateDelayTime`,payload,options)
        .then(response => {;
            return response.data;
        });
}

function updateOrderPageDefaultForAll(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/admin_app_config/updateOrderPageDefaultForAll`,payload,options)
        .then(response => {;
            return response.data;
        });
}
function updateOrderCacheLogValue(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/admin_app_config/updateOrderCacheLogValue`,payload,options)
        .then(response => {;
            return response.data;
        });
}

function updateLowRecaptchaIpsValue(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/admin_app_config/updateLowRecaptchaIpsValue`,payload,options)
        .then(response => {;
            return response.data;
        });
}

function updateSendUpdateNotif(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/admin_app_config/updateSendUpdateNotif`,payload,options)
        .then(response => {;
            return response.data;
        });
}

function updateDelayOptions(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/admin_app_config/update`,payload,options)
        .then(response => {;
            return response.data;
        });
}
function checkAdminPassword(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/admin-utility/check-password`,payload,options)
        .then(response => {
            return response.data;
        });
}

export default {
    actualAppConfig,
    updateDelayTime,
    updateOrderPageDefaultForAll,
    updateOrderCacheLogValue,
    updateLowRecaptchaIpsValue,
    updateAppVersion,
    updateSendUpdateNotif,
    updateDelayOptions,
    checkAdminPassword
};